<template>
  <b-row>
    <b-col cols="8">
      <b-card>
        <b-col class="col-12 text-center">
          <img
            src="@/assets/images/approve/1.png"
            width="100%"
          >
        </b-col>
      </b-card>
    </b-col>
    <RightTab />
  </b-row>

</template>

<script>
import {
  BRow, BCol, BFormTextarea, BCard, BFormRadio, BTab, BTabs, BButton,
} from 'bootstrap-vue'
import RightTab from './components/RightTab.vue'
import TabAttachFiles from './components/TabAttachFiles.vue'

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    RightTab,
    TabAttachFiles,
  },
}
</script>

 <style lang="scss" >

</style>
